import CostHTMLPreviewBaseSection from './CostHTMLPreviewBaseSection'
import {ReportGroupingLevel} from '../../../constants'

export default function CostHTMLPreviewGroupingSection() {}

CostHTMLPreviewGroupingSection.prototype = new CostHTMLPreviewBaseSection();

CostHTMLPreviewGroupingSection.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, groupingRowsCount )
{
    CostHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.groupingRowsCount = groupingRowsCount;
    return this;
};

CostHTMLPreviewGroupingSection.prototype.addRows = function( tBody )
{
    this.addRowWithMainCell( tBody, this.message( "report.cost.total_for_working_time" ), "totalForWorkingTime", "totalForWorkingTimeRow" );

    var rowsCount = 0;
    while( true )
    {
        this.addGroupingRow( tBody, this.firstGroupingLevel, "firstLevel", "firstGrouping" );
        if( ++rowsCount >= this.groupingRowsCount ) break;

        if( this.secondGroupingLevel != ReportGroupingLevel.NONE )
        {
            this.addGroupingRow( tBody, this.secondGroupingLevel, "secondLevel", "secondGrouping" );
            if( ++rowsCount >= this.groupingRowsCount ) break;
        }

        if( this.thirdGroupingLevel != ReportGroupingLevel.NONE )
        {
            this.addThirdGroupingRow( tBody );
            if( ++rowsCount >= this.groupingRowsCount ) break;

            if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.thirdGroupingLevel, [this.firstGroupingLevel, this.secondGroupingLevel]))
            {
                this.addThirdGroupingRow( tBody );
                if( ++rowsCount >= this.groupingRowsCount ) break;
            }
        }
    }
};

CostHTMLPreviewGroupingSection.prototype.addGroupingRow = function( tBody, groupingLevel, mainCellClassName, rowClassName )
{
    this.addRowWithMainCell( tBody, ReportPreviewUtils.getLevelPreviewName( groupingLevel ), mainCellClassName, rowClassName );
};

CostHTMLPreviewGroupingSection.prototype.addThirdGroupingRow = function( tBody )
{
    this.addGroupingRow(
            tBody,
            this.thirdGroupingLevel,
            this.secondGroupingLevel == ReportGroupingLevel.NONE ? "secondLevel" : "thirdLevel"
    );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewGroupingSection.js